import { Search } from '@ibsys/kit';
import { ChangeEvent, FC, FormEvent } from 'react';

type Props = {
  value: string;
  /** Вызывается на каждый набранный символ, а также при очистке поля */
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
};

/**
 * Поле поиска, отдающее набранное сразу, а не по завершении ввода.
 *
 * `Search` из kit держит набранное в своём состоянии и вызывает `onChange` только по уходу
 * фокуса, Enter и очистке. Там, где выдачу набирает запрос по строке, этого мало: пользователь
 * печатает, видит прежний список и считает искомое отсутствующим. Событие ввода самого поля kit
 * не перехватывает — оно и даёт каждый символ; `onChange` оставлен ради очистки, которая меняет
 * значение, не порождая ввода.
 */
export const LiveSearch: FC<Props> = ({ value, onChange, placeholder, className }) => (
  <Search
    value={value}
    placeholder={placeholder}
    className={className}
    onInput={(event: FormEvent<HTMLInputElement>) => onChange(event.currentTarget.value)}
    onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
  />
);
